/**
 * GlobalStatusPicker — Dialog wrapper for UserStatusPicker.
 *
 * Opened via Cmd+Y keyboard shortcut. Reads statusPicker state from
 * viewContext and renders as a centered dialog.
 */

import { memo } from "react"
import { useViewContext } from "@/app/stores/viewContext"
import { Dialog, DialogContent, DialogTitle } from "@/app/components/ui/dialog"
import { UserStatusPicker } from "@/shared/components/UserStatusPicker"

export const GlobalStatusPicker = memo(function GlobalStatusPicker() {
  const statusPicker = useViewContext((s) => s.statusPicker)
  const closePickers = useViewContext((s) => s.closePickers)

  if (!statusPicker) return null

  return (
    <Dialog open onOpenChange={(open) => { if (!open) closePickers() }}>
      <DialogContent className="max-w-xs p-2">
        <DialogTitle className="sr-only">Set Status</DialogTitle>
        <UserStatusPicker
          taskId={statusPicker.taskIds}
          onClose={closePickers}
        />
      </DialogContent>
    </Dialog>
  )
})
